import useAppContext from 'flow/hooks/useAppContext';
import { isEmptyNullOrUndefined } from 'flow/utils';
import React from 'react';

interface Props {
    timeInSeconds: number;
}

const TimeWidget = ({ timeInSeconds }: Props) => {
    const { i18next } = useAppContext();

    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    return (
        <div className="flex size-24 items-center justify-center rounded-full border text-gray-300 md:size-28 dark:border-gray-500">
            {!isEmptyNullOrUndefined(timeInSeconds) && (
                <div className="flex gap-x-2">
                    <div className="flex items-end">
                        <div className="text-2xl font-bold text-gray-800">
                            {minutes}
                        </div>
                        <div className="text-sm font-bold text-gray-700">
                            {i18next.t('Queue.Statistics.Time.Minute')}
                        </div>
                    </div>

                    <div className="flex items-end">
                        <div className="text-2xl font-bold text-gray-800">
                            {seconds}
                        </div>
                        <div className="text-sm font-bold text-gray-700">
                            {i18next.t('Queue.Statistics.Time.Second')}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TimeWidget;
